import CollectProgress from './CollectProgress';

export default CollectProgress;
